export default __webpack_public_path__ + "static/media/Calendário.2d5b101c.svg";